import { render, staticRenderFns } from "./SLGATransactionStore.vue?vue&type=template&id=76f5c651&"
import script from "./SLGATransactionStore.vue?vue&type=script&lang=js&"
export * from "./SLGATransactionStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports